import React from 'react';
import { Link } from 'react-router-dom';

const SiteFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{
      position: 'relative',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
      color: '#fff',
      padding: '25px 15px 20px',
      marginTop: '15px',
      width: '100%'
    }}>
      <div style={{
        maxWidth: '480px',
        margin: '0 auto'
      }}>
        {/* Main Footer Content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '15px',
          marginBottom: '20px'
        }}>
          {/* Brand Section */}
          <div>
            <div style={{
              marginBottom: '15px'
            }}>
              <span style={{ fontSize: '16px', marginRight: '4px' }}>🎵</span>
              <span style={{
                fontSize: '26px',
                fontWeight: '800',
                fontFamily: "'Satisfy', 'Dancing Script', cursive",
                background: 'linear-gradient(135deg, #ff416c, #ff4b2b, #ff6b35)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                textShadow: '0 0 30px rgba(255,65,108,0.3)',
                letterSpacing: '1px'
              }}>
                Geet Suhane
              </span>
              <span style={{ fontSize: '16px', marginLeft: '4px' }}>🎶</span>
            </div>
            <p style={{
              color: '#a0a0a0',
              fontSize: '14px',
              lineHeight: '1.6',
              fontStyle: 'italic'
            }}>
              ♪ Where music lovers connect, share, and celebrate the joy of singing ♪
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{
              fontSize: '16px',
              fontWeight: '600',
              marginBottom: '15px',
              color: '#fff'
            }}>
              Quick Links
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              <li style={{ marginBottom: '10px' }}>
                <Link to="/" style={{
                  color: '#a0a0a0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s'
                }}>Home</Link>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <Link to="/moments" style={{
                  color: '#a0a0a0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  display: 'inline-block',
                  padding: '4px 0'
                }}>Moments</Link>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <Link to="/fs" style={{
                  color: '#a0a0a0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  display: 'inline-block',
                  padding: '4px 0'
                }}>Karaoke</Link>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <Link to="/room" style={{
                  color: '#a0a0a0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  display: 'inline-block',
                  padding: '4px 0'
                }}>Voice Room</Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 style={{
              fontSize: '16px',
              fontWeight: '600',
              marginBottom: '15px',
              color: '#fff'
            }}>
              Legal
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              <li style={{ marginBottom: '10px' }}>
                <Link to="/privacy" style={{
                  color: '#a0a0a0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  display: 'inline-block',
                  padding: '4px 0'
                }}>Privacy Policy</Link>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <Link to="/terms" style={{
                  color: '#a0a0a0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  display: 'inline-block',
                  padding: '4px 0'
                }}>Terms of Service</Link>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <Link to="/community" style={{
                  color: '#a0a0a0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  display: 'inline-block',
                  padding: '4px 0'
                }}>Community Guidelines</Link>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <Link to="/about" style={{
                  color: '#a0a0a0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  display: 'inline-block',
                  padding: '4px 0'
                }}>About Us</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{
              fontSize: '16px',
              fontWeight: '600',
              marginBottom: '15px',
              color: '#fff'
            }}>
              Contact Us
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              <li style={{
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{ fontSize: '18px' }}>📧</span>
                <a href="mailto:support@geetsuhane.com" style={{
                  color: '#a0a0a0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  display: 'inline-block',
                  padding: '4px 0'
                }}>support@geetsuhane.com</a>
              </li>
              <li style={{
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{ fontSize: '18px' }}>📱</span>
                <a href="https://wa.me/13322878300" target="_blank" rel="noopener noreferrer" style={{
                  color: '#a0a0a0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  display: 'inline-block',
                  padding: '4px 0'
                }}>WhatsApp: +1 332 287 8300</a>
              </li>
            </ul>
            {/* Social Icons */}
            <div style={{
              display: 'flex',
              gap: '12px',
              marginTop: '15px'
            }}>
              <a href="https://www.facebook.com/geetsuhane" target="_blank" rel="noopener noreferrer" style={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                textDecoration: 'none',
                transition: 'background 0.2s'
              }}>
                <i className="feather-facebook" style={{ fontSize: '16px' }}></i>
              </a>
              <a href="https://www.instagram.com/geetsuhane" target="_blank" rel="noopener noreferrer" style={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                textDecoration: 'none'
              }}>
                <i className="feather-instagram" style={{ fontSize: '16px' }}></i>
              </a>
              <a href="https://www.youtube.com/@geetsuhane" target="_blank" rel="noopener noreferrer" style={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                textDecoration: 'none'
              }}>
                <i className="feather-youtube" style={{ fontSize: '16px' }}></i>
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div style={{
          height: '1px',
          background: 'rgba(255,255,255,0.1)',
          margin: '20px 0'
        }}></div>

        {/* Copyright */}
        <div style={{
          textAlign: 'center',
          color: '#666',
          fontSize: '13px'
        }}>
          <p style={{ margin: 0 }}>
            © {currentYear} Geet Suhane. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
